import { render } from "./SidebarItem.vue?vue&type=template&id=695fbbcd"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/foderboxen/admin.foderboxen.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__